import { KeyTextField } from '@prismicio/client';
import styles from './gradientPlate.module.scss';

interface GradientPlateProps {
  text: KeyTextField;
}

export const GradientPlate = ({ text }: GradientPlateProps) => {
  return <div className={styles.plate}>{text}</div>;
};
